import styled, { css } from 'styled-components';

export const ImageWrapper = styled.div<{
  $scalable: boolean;
  $showPreviewWithButton?: boolean;
}>`
  padding-bottom: 100%;
  width: 100%;
  height: 0;
  position: relative;
  overflow: hidden;
  ${props =>
    props.$scalable &&
    css`
      &:hover {
        img {
          transform: scale(1.1);
        }
      }
      img {
        transition: all 0.5s ease 0s;
      }
    `}

  ${props =>
    props.$showPreviewWithButton &&
    css`
      &:hover {
        div:last-child {
          opacity: 0.5;
        }
        > div:nth-child(2) {
          transform: translate(-50%, -50%) scale(1.1);
          transition: transform 0.5s ease-in-out 0s;
        }
      }
    `}
`;

export const VideoWrapper = styled.div`
  padding-bottom: 100%;
  width: 100%;
  height: 0;
  position: relative;
  overflow: hidden;
`;

export const Image = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: auto;
  vertical-align: middle;
`;

export const PlayButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 3;
  cursor: pointer;
  border-radius: 80px;
  width: 80px;
  height: 80px;
  overflow: hidden;
  color: var(--v3-black-0);
`;

export const IconPre = styled.div`
  position: absolute;
  background: var(--v3-black-0);
  opacity: 0.5;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 80px;
  height: 80px;
`;

export const ImageOverlay = styled.div`
  position: absolute;
  inset: 0;
  width: 100%;
  height: auto;
  background: var(--v3-black-100);
  opacity: 0;
`;
